import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import CpsTable from './_CpsTable.js';
import { Card, Col, Form, Row } from 'react-bootstrap';
import EditCp from './_EditCp.js';
const URI = ApiEndpoint + 'configuration/';
const CodigosPostales = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);
  const [cps, setCps] = useState([]);
  const [selectedState, setSelectedState] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [idCpToEdit, setIdCpToEdit] = useState(0);
  const handleClose = () => {
    setOpenModal(false);
    getCpsList(selectedState);
  };

  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URI + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
          setSelectedState(0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCpsList = async () => {
    console.log('entre a getCitiesList');
    setCps(null);

    httpClient(
      'GET',
      URI + 'codigospostales/' + selectedState,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setCps(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getStatesList();
    getCpsList(0);
  }, []);

  useEffect(() => {
    if (selectedState != null && selectedState != 0) getCpsList(selectedState);
  }, [selectedState]);

  return (
    <>
      <Card className="mb-3">
        <Card.Header>
          <Row className="flex-end-center mb-3">
            <Col xs="auto" sm={6} lg={4}>
              <Form.Label>Filtrar por Estado</Form.Label>
              <select
                aria-label="Default select"
                name="idestado"
                id="idestado"
                onChange={e => {
                  setSelectedState(e.target.value);
                }}
                value={`${selectedState}`}
                style={{ minWidth: '250px' }}
              >
                <option key={'location_0'} value="0">
                  Todos los Estados
                </option>
                {!!states?.length &&
                  states.map(estado => (
                    <option key={estado.idestado} value={estado.idestado}>
                      {estado.descripcion}
                    </option>
                  ))}
              </select>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          {cps && (
            <CpsTable
              cps={cps}
              setIdCp={setIdCpToEdit}
              setOpenModal={setOpenModal}
            ></CpsTable>
          )}
          {openModal && (
            <MyModal
              id="id_myModal"
              title={(idCpToEdit > 0 ? 'Editar' : 'Agregar') + ' Codigo Postal'}
              openModal={openModal}
              closeModal={handleClose}
            >
              <></>
              <EditCp closeModal={handleClose} idCp={idCpToEdit}></EditCp>
            </MyModal>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default CodigosPostales;
